
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexSOcmfq5e8KXVzcIUS_5oxX2VRFMCVTqsx99aDFctC4UMeta } from "/github/workspace/pages/index.vue?macro=true";
import { default as not_45foundHSswfzjFWGHe1KzTnTcfMS6bf_NXCMrn20UtLwGpuj4Meta } from "/github/workspace/pages/not-found.vue?macro=true";
import { default as placeholdersCIxNnVFCJo9jTO6pXLvgPakdm5Rpu4uTAZEU8M6tQUMeta } from "/github/workspace/pages/placeholder.vue?macro=true";
import { default as donepyJtNv60ljUwiZL7WRmsZLOLlM58xJLP2PfXHVWnsacMeta } from "/github/workspace/pages/callcenter/done.vue?macro=true";
import { default as confirmYCn0CKpAQWsuNjR7HUAroZ32hJ6viZj78t5bQuLQgNwMeta } from "/github/workspace/pages/callcenter/confirm.vue?macro=true";
import { default as _91workorderId_933DuChbaPCPQlOViHrm7PwjeZCoKejCpFSI5LGVj7Q3sMeta } from "/github/workspace/pages/callcenter/[workorderId].vue?macro=true";
import { default as _91workorderId_93sM9QGOQ7g_WqDfrFVMNtZTQHM_45JTh1eerspuKIVAZ84Meta } from "/github/workspace/pages/appointment/[workorderId].vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/github/workspace/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/github/workspace/pages/index.vue")
  },
  {
    name: "not-found___en",
    path: "/not-found",
    component: () => import("/github/workspace/pages/not-found.vue")
  },
  {
    name: "not-found___es",
    path: "/es/not-found",
    component: () => import("/github/workspace/pages/not-found.vue")
  },
  {
    name: "placeholder___en",
    path: "/placeholder",
    component: () => import("/github/workspace/pages/placeholder.vue")
  },
  {
    name: "placeholder___es",
    path: "/es/placeholder",
    component: () => import("/github/workspace/pages/placeholder.vue")
  },
  {
    name: "callcenter-done___en",
    path: "/callcenter/done",
    meta: donepyJtNv60ljUwiZL7WRmsZLOLlM58xJLP2PfXHVWnsacMeta || {},
    component: () => import("/github/workspace/pages/callcenter/done.vue")
  },
  {
    name: "callcenter-done___es",
    path: "/es/callcenter/done",
    meta: donepyJtNv60ljUwiZL7WRmsZLOLlM58xJLP2PfXHVWnsacMeta || {},
    component: () => import("/github/workspace/pages/callcenter/done.vue")
  },
  {
    name: "callcenter-confirm___en",
    path: "/callcenter/confirm",
    meta: confirmYCn0CKpAQWsuNjR7HUAroZ32hJ6viZj78t5bQuLQgNwMeta || {},
    component: () => import("/github/workspace/pages/callcenter/confirm.vue")
  },
  {
    name: "callcenter-confirm___es",
    path: "/es/callcenter/confirm",
    meta: confirmYCn0CKpAQWsuNjR7HUAroZ32hJ6viZj78t5bQuLQgNwMeta || {},
    component: () => import("/github/workspace/pages/callcenter/confirm.vue")
  },
  {
    name: "callcenter-workorderId___en",
    path: "/callcenter/:workorderId()",
    meta: _91workorderId_933DuChbaPCPQlOViHrm7PwjeZCoKejCpFSI5LGVj7Q3sMeta || {},
    component: () => import("/github/workspace/pages/callcenter/[workorderId].vue")
  },
  {
    name: "callcenter-workorderId___es",
    path: "/es/callcenter/:workorderId()",
    meta: _91workorderId_933DuChbaPCPQlOViHrm7PwjeZCoKejCpFSI5LGVj7Q3sMeta || {},
    component: () => import("/github/workspace/pages/callcenter/[workorderId].vue")
  },
  {
    name: "appointment-workorderId___en",
    path: "/appointment/:workorderId()",
    component: () => import("/github/workspace/pages/appointment/[workorderId].vue")
  },
  {
    name: "appointment-workorderId___es",
    path: "/es/appointment/:workorderId()",
    component: () => import("/github/workspace/pages/appointment/[workorderId].vue")
  }
]